module.exports = __webpack_public_path__ + "static/img/11-4.1f5f2120.jpg";